import React, { useState, useEffect } from 'react';
import { PageContainer, proTheme } from "@ant-design/pro-components";
import {message, Spin, Table, Typography, Button, Modal} from 'antd';
import { useNavigate } from "react-router-dom";
import {fetchProfile} from "../components/Profile";
import {fetchIndividuals, fetchTeams, fetchTeamMembers} from "../components/RatingTable";
import { baseBackendUrl } from '../shared/constants';
const { Title } = Typography;

const TeamRanking = () => {
    const [dataSource, setDataSource] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [participants, setParticipants] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const theme= proTheme.useToken()
    
    const token = localStorage.getItem('token');
    document.title = "Таблица рейтинга";
    useEffect(() => {
        document.title = "Таблица рейтинга";
        async function loadProfile() {
            try {
                const data = await fetchProfile(token);
            } catch (error) {
                localStorage.removeItem('token');
                navigate("/login");
            }
        }
        if (token) {
            loadProfile();
        }
        loadTeams();
        fetchParticipants();
        setLoading(false);
        const interval = setInterval(() => {
            loadTeams();
            fetchParticipants();
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const loadTeams = async () => {
        try {
            const teams = await fetchTeams();
            setDataSource(teams);
        } catch (error) {
            message.error("Ошибка загрузки данных");
        }
    };

    const handleShowModal = async (record) => {
        const members = await fetchTeamMembers(record.team_name);
        setSelectedTeam({ ...record, members });
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedTeam(null);
    };

    const columns = [
        {
            title: 'Место',
            dataIndex: 'rank',
            key: 'rank',
            sorter: (a, b) => a.rank - b.rank,
        },
        {
            title: 'Команда',
            dataIndex: 'team_name',
            key: 'team_name',
            render: (text, record) => (
                <Button type="link" style={{color: theme.token.colorText}} onClick={() => handleShowModal(record)}>
                    <strong>{text}</strong>
                </Button>
            ),
        },
        {
            title: 'Очки',
            dataIndex: 'points',
            key: 'points',
            sorter: (a, b) => a.points - b.points,
        }
    ];

    const individualColumns = [
        {
            title: "Место",
            dataIndex: "rank",
            key: "rank"
        },
        {
            title: "Имя",
            dataIndex: "team_name",
            key: "team_name"
        },
        {
            title: "Очки",
            dataIndex: "points",
            key: "points"
        },
    ]
    const fetchParticipants = async () => {
        const data = await fetchIndividuals();
        setParticipants(data);
    };

    if (loading) return <Spin size="large" style={{ display: 'block', margin: '50px auto' }} />;

    return (
        <PageContainer
            title="Рейтинг команд"
            content="Актуальные данные рейтинга команд Code.ak!"
        >
            {dataSource && dataSource.filter((team) => !["none", "admin", "mentor"].includes(team.team_name)).length > 0 && (
                <Table
                    columns={columns}
                    dataSource={dataSource.filter((team) => !["none", "admin", "mentor"].includes(team.team_name))}
                    rowKey="id"
                    pagination={{ pageSize: 10 }}
                    toolBarRender={() => []}
                    scroll={{ x: 'max-content' }}
                />
            )}
            {participants && participants.length > 0 && (
                <>
                    <Title level={4} style={{ marginTop: 12, marginBottom: 12 }}>
                        Рейтинг индивидуальных участников
                    </Title>
                    <Table
                        dataSource={participants}
                        columns={individualColumns}
                        rowKey="id"
                        pagination={{ pageSize: 10 }}
                        scroll={{ x: 'max-content' }}
                    />
                </>
            )}
            {dataSource.filter((team) => !["none", "admin", "mentor"].includes(team.team_name)).length === 0 && participants.length === 0 && (
                <Title level={5} type="secondary" style={{ marginTop: 24 }}>
                    Актуальные данные появятся после формирования команд!
                </Title>
            )}
            <Modal
                visible={isModalVisible}
                onCancel={handleCloseModal}
                footer={[
                    <Button key="ok" onClick={handleCloseModal}>
                        Закрыть
                    </Button>,
                ]}
            >
                {selectedTeam ? (
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <h2>Участники команды {selectedTeam.team_name}</h2>
                        {selectedTeam.members && selectedTeam.members.length > 0 ? (
                            selectedTeam.members.map((member, index) => (
                                <li
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '10px',
                                        fontWeight: member.is_capitan ? 'bold' : 'normal',
                                        color: member.is_capitan ? '#667eea' : 'inherit',
                                    }}
                                >
                                    <img
                                        src={`${baseBackendUrl}/uploads/${member.avatar || 'default-avatar.png'}`}
                                        alt={member.username}
                                        style={{ width: 40, height: 40, borderRadius: '50%', marginRight: 10 }}
                                    />
                                    <span>
              {member.username} {member.lastname} ({member.login})
                                        {member.is_capitan && (
                                            <span style={{ marginLeft: 8, color: '#faad14' }}>является капитаном</span>
                                        )}
            </span>
                                </li>
                            ))
                        ) : (
                            <li>Участники не найдены</li>
                        )}
                    </ul>
                ) : (
                    <p>Загрузка...</p>
                )}
            </Modal>
        </PageContainer>
    );
};

export default TeamRanking;
